import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  aggregate_borrowing_amount: {
    order: 210,
    name: 'Available financing amount'
  }
};

export function FinancingLiquidity({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.FINANCING_PROFILE,
    onChangeFund,
    schema: schema.FINANCING_PROFILE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.FINANCING_PROFILE?.field_names || [],
    funds,
    isMultiFunds,
    tableName: 'FINANCING_PROFILE',
    columnLables
  });

  return (
    <Table
      id="reporttables-financing-liquidity-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
